import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton, ModalSecondaryButton } from '../..';
import { ModalClose, useBCMSModal } from "@bcm-dev/bcms-vite";
import "./styles.css";

/**
 * @function CancelDisputeTransactionModal
 * @return {React.Component}
 * @exported true
 * @description The cancel dispute transaction modal
 */

export default function CancelDisputeTransactionModal(props) {
  const { close } = useBCMSModal();

  const onCancel = evt => {
    close("CancelDisputeTransactionModal");
    
    if(props.data) {
      props.data.onCancel(evt);
    }
  }

  return(
    <CustomModal className="cancel-dispute-transaction-modal" id="CancelDisputeTransactionModal">
      <CustomModalContent>
          <p className="text-center">Are you sure you want to cancel? The information you have entered
          will be lost. A dispute request for the transaction wil not be submitted.</p>
      </CustomModalContent>
      <CustomModalFooter className="button-container">
          <ModalPrimaryButton text="Yes" onClick={ onCancel } />
          <ModalClose id="CancelDisputeTransactionModal">
            <ModalSecondaryButton text="No" />
          </ModalClose>
      </CustomModalFooter>
    </CustomModal>
  );
}